import { inject } from '@angular/core';
import { PwaUpdateService } from './core/service/pwa-update.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { AnalyticsService } from './core/service/analytics/analytics.service';
import { PremiacionRealtimeSyncService } from './core/service/premiacion-realtime-sync.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  standalone: false,
  styleUrl: './app.scss'
})
export class App implements OnInit, OnDestroy {
  public readonly pwaUpdate = inject(PwaUpdateService);
  private routerEventsSub: Subscription | null = null;

  constructor(
    private readonly premiacionRealtimeSyncService: PremiacionRealtimeSyncService,
    private readonly router: Router,
    private readonly analyticsService: AnalyticsService
  ) {}

  public ngOnInit(): void {
    this.pwaUpdate.initialize();
    this.premiacionRealtimeSyncService.initialize();

    this.analyticsService.initialize();
    this.routerEventsSub = this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.analyticsService.trackPageView(event.urlAfterRedirects));
  }

  public ngOnDestroy(): void {
    this.routerEventsSub?.unsubscribe();
    this.routerEventsSub = null;

    this.premiacionRealtimeSyncService.destroy();
  }
}